var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87823",
    "data-name": "Group 87823",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14977",
    "data-name": "Rectangle 14977",
    width: 27,
    height: 27,
    rx: 7,
    fill: "#ffefde"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-call",
    "data-name": "Icon ionic-ios-call",
    d: "M18.783,16.026A12.362,12.362,0,0,0,16.2,14.3c-.774-.372-1.057-.364-1.605.031-.456.33-.751.636-1.276.521a7.611,7.611,0,0,1-2.563-1.9,7.556,7.556,0,0,1-1.9-2.563c-.111-.529.2-.82.521-1.276.395-.548.406-.831.031-1.605A12.118,12.118,0,0,0,7.683,4.926c-.563-.563-.69-.441-1-.33a5.69,5.69,0,0,0-.916.487,2.762,2.762,0,0,0-1.1,1.161c-.218.471-.471,1.349.816,3.64a20.31,20.31,0,0,0,3.571,4.762h0l0,0,0,0h0a20.389,20.389,0,0,0,4.762,3.571c2.291,1.287,3.169,1.034,3.64.816a2.715,2.715,0,0,0,1.161-1.1,5.691,5.691,0,0,0,.487-.916C19.224,16.716,19.35,16.589,18.783,16.026Z",
    transform: "translate(1.651 1.639)",
    fill: "#f49e49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioCallIcon);
export default __webpack_public_path__ + "static/media/audio_call_icon.93cc48e0.svg";
export { ForwardRef as ReactComponent };